import { DOMParser as ProseMirrorDOMParser } from "prosemirror-model";
import sanitizeHtml from "sanitize-html";

import { focusSchema } from "../schema";
import { hydratePlainTextMentions } from "./mentions";

export const parseHtmlToDoc = (html: string) => {
  const root = document.createElement("div");
  root.innerHTML = sanitizeHtml(html, {
    allowedAttributes: {
      "*": ["class", "style"],
      a: ["href", "name", "target", "title"],
      code: ["class"],
      img: ["alt", "height", "src", "title", "width"],
      li: ["data-checked"],
      ol: ["start"],
      td: ["colspan", "rowspan"],
      th: ["colspan", "rowspan"],
    },
    allowedSchemes: ["http", "https", "mailto", "tel", "data"],
    allowedStyles: {
      "*": {
        "font-style": [/^italic$/, /^normal$/],
        "font-weight": [/^bold$/, /^bolder$/, /^normal$/, /^[1-9]00$/],
        "text-decoration": [/^line-through$/, /^underline$/],
      },
    },
    allowedTags: [
      "a",
      "b",
      "blockquote",
      "br",
      "code",
      "del",
      "div",
      "em",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hr",
      "i",
      "img",
      "li",
      "ol",
      "p",
      "pre",
      "s",
      "span",
      "strike",
      "strong",
      "table",
      "tbody",
      "td",
      "th",
      "thead",
      "tr",
      "u",
      "ul",
    ],
  });

  return hydratePlainTextMentions(
    ProseMirrorDOMParser.fromSchema(focusSchema).parse(root),
  );
};
